import cn from 'classnames';
import type { FC } from 'react';

import type { AgentFindingCountsV1 } from '@/model/Agent.model';

import FindingChip from './FindingChip';
import styles from './FindingChip.module.scss';

interface FindingChipsProps {
  counts: AgentFindingCountsV1;
  /** Renders every chip in the resting grey, for rows that should not compete for attention. */
  muted?: boolean;
  className?: string;
  testId?: string;
}

/** The severity breakdown of a completed run, as one pill per non-zero count. */
const FindingChips: FC<FindingChipsProps> = ({ counts, muted = false, className, testId }) => {
  const { critical, warning, info } = counts;

  return (
    <div
      className={cn(styles.group, className)}
      data-test-component="FindingChips"
      data-test-element="group"
      data-testid={testId}
    >
      {critical + warning + info === 0 ? (
        <FindingChip tone="neutral">No issues found</FindingChip>
      ) : (
        <>
          {critical > 0 && <FindingChip tone={muted ? 'neutral' : 'critical'}>{critical} Critical</FindingChip>}
          {warning > 0 && (
            <FindingChip tone={muted ? 'neutral' : 'warning'}>
              {warning} {warning === 1 ? 'Warning' : 'Warnings'}
            </FindingChip>
          )}
          {info > 0 && <FindingChip tone={muted ? 'neutral' : 'info'}>{info} Info</FindingChip>}
        </>
      )}
    </div>
  );
};

export default FindingChips;
